import { createRouter, createWebHistory } from 'vue-router/auto'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { routes } from 'vue-router/auto-routes'
import { setupLayouts } from 'virtual:meta-layouts'
import { recordRecentPage } from '@/utils/recentPages'
import { keycloakReady } from '@/plugins/vuekeycloak'

async function authGuard(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  if (!to.meta.requiresAuth) {
    next() // Allow access
    return
  }

  // Sans cette attente, la première navigation se fait alors que `isAuthenticated` vaut encore
  // `false` par défaut, ce qui renvoyait l'utilisateur déjà connecté vers /login.
  await keycloakReady

  const { isAuthenticated } = useKeycloak()
  if (!isAuthenticated.value) {
    // `to.fullPath` contient déjà son propre `?`/`&` : le passer tel quel dans une chaîne
    // concaténée casse le parsing de la query de `/login` (tout après le 2e `?`/`&` devient
    // un paramètre de `/login` au lieu de faire partie de `return_url`). La forme objet laisse
    // vue-router encoder correctement la valeur.
    next({ path: '/login', query: { return_url: to.fullPath } }) // Redirect to login page
  }
  else {
    next() // Allow access
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: setupLayouts(routes),
})

router.beforeEach(authGuard)

router.afterEach((to) => {
  recordRecentPage(to)
})

export default router
